import React, { useCallback, useContext } from 'react';
import { Button } from '@vodafoneis/sjonvarpskjarni-js-lib';
import styled from 'styled-components';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';
import pipIcon from '../../../../../public/images/pip.png';

const PlaybackSettingsPipButton = styled(Button)`
	width: 20px;
	height: 20px;
	background: url(${pipIcon.src}) no-repeat;
	background-size: 100% 100%;
`;

export const PlaybackSettingsPip: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	const onPIPButtonPressed = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();
			player.togglePIP();
		},
		[player]
	);

	if (!player || !player.supportsPIP()) return null;

	return <PlaybackSettingsPipButton onClick={onPIPButtonPressed} />;
};
